import { createContext } from "react";

export const SystemLoading = createContext({});
export const initLoad = { isShow: false, message: "" };

export function loadReducer(state, action) {
  switch (action.type) {
    case "OPEN":
      return { isShow: true, message: action?.payload?.message || "" };
    case "CLOSE":
      return { isShow: false, message: "" };
    default:
      throw state;
  }
}

export function checkLoading(dispatch, isLoad = true, message = "") {
  if (isLoad) {
    dispatch({ type: "OPEN", payload: { message } });
    return;
  }
  dispatch({ type: "CLOSE" });
}